export default "__VITE_ASSET__BFpumICf__"